<template>
  <div>
    <ts-card-wrapper>
      <form class="form-horizontal">
        <div class="row">
          <div class="col-md-2 form-group">
            <label>{{ $t('carAttendance.busNo') }}</label>
            <treeselect
              :load-options="loadVehicle"
              :options="vehicleOptions"
              :placeholder="$t('all')"
              v-model="model.vehicle_id"
            />
          </div>
          <div class="col-md-4 form-group">
            <label>{{ $t('carAttendance.driverName') }}</label>
            <treeselect
              :load-options="loadDrivers"
              :multiple="true"
              :limit="1"
              :options="driversOptions"
              :placeholder="$t('all')"
              v-model="model.driver_staff_id"
            />
          </div>
          <div class="col-md-2">
            <label></label>
            <ts-button
              @click="fetchData"
              class="mt-4"
              color="primary"
              :waiting="loading"
              >{{ $t('view') }}</ts-button
            >
            <label></label>
            <ts-button
              outline
              class="ml-2 mt-4"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
    <div class="overflow-auto">
      <ts-table
        :records="resources"
        :columnLengths="18"
        :rowGroup="{
          field: 'employee_name'
        }"
      >
        <template v-slot:thead>
          <thead>
            <tr>
              <th rowspan="2">{{ $t('carAttendance.date') }}</th>
              <th rowspan="2">{{ $t('carAttendance.cardNumber') }}</th>
              <th rowspan="2">{{ $t('carAttendance.studentName') }}</th>
              <th rowspan="2">{{ $t('carAttendance.bordingNo') }}</th>
              <th colspan="4" class="text-center">
                {{ $t('carAttendance.student') }}
              </th>
              <th colspan="4" class="text-center">
                {{ $t('carAttendance.parentAcknowledgement') }}
              </th>
            </tr>
            <tr>
              <th>{{ $t('carAttendance.checkin') }}</th>
              <th>{{ $t('carAttendance.location') }}</th>
              <th>{{ $t('carAttendance.checkout') }}</th>
              <th>{{ $t('carAttendance.location') }}</th>
              <th>{{ $t('carAttendance.cardNumber') }}</th>
              <th>{{ $t('carAttendance.name') }}</th>
              <th>{{ $t('carAttendance.ackTime') }}</th>
              <th>{{ $t('carAttendance.location') }}</th>
            </tr>
            <TableProgressBar v-show="loading" :columnLength="12" />
          </thead>
        </template>
        <template v-slot="{ record }">
          <td class="ts-whitespace-no-wrap">{{ record.picked_up_date }}</td>
          <td class="ts-whitespace-no-wrap">
            {{ record.student.card_number }}
          </td>
          <td class="ts-whitespace-no-wrap">
            {{ record.student.student_name }}
          </td>
          <td class="ts-whitespace-no-wrap">{{ record.board_no }}</td>
          <td class="ts-whitespace-no-wrap">{{ record.check_in }}</td>
          <td class="ts-whitespace-no-wrap">{{ record.check_in_location }}</td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.check_out }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.check_out_location }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.parent_card_number }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.parent_card_number }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.parent_acknowledge }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.parent_ack_location }}
          </td>
        </template>
      </ts-table>
    </div>
    <div class="d-flex justify-content-between align-items-center p-15">
      <ts-total-list v-model="pagination" />
      <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
    </div>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <ts-branch-filter @filter="value => (branch_id = value)" />
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'carAttendance',
  components: { TableProgressBar },
  data() {
    return {
      loading: false,
      model: {
        vehicle_id: null,
        driver_staff_id: []
      },
      branch_id: [],
      visible: false,
      driversOptions: null,
      vehicleOptions: null,
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('carAttendance', ['resources', 'pagination'])
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('carAttendance', ['fetchVehicle', 'fetchDrivers']),
    async loadVehicle({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.vehicleOptions = null
        let response = await this.fetchVehicle()
        this.vehicleOptions = response.data.map(el => ({
          id: el.vehicle_id,
          label: el.plate_no + '|' + el.model
        }))
      }
    },
    async loadDrivers({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.driversOptions = null
        if (this.model.vehicle_id) {
          await this.fetchDrivers({
            vehicle_id: this.model.vehicle_id
          })
            .then(response => {
              this.driversOptions = response.data.map(el => ({
                id: el.driver_staff_id,
                label: el.name_en
              }))
            })
            .catch(error => {
              this.$toasted.error(error.message)
            })
        }
      }
    },
    fetchData(attributes) {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'carAttendance/fetch',
          Object.assign(
            {},
            this.model,
            { branch_id: this.branch_id },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    }
  },
  watch: {
    'model.vehicle_id': function(value) {
      this.model.driver_driver_staff_id = []
      this.driversOptions = null
      if (value) {
        this.fetchVehicle({ vehicle_id: value })
      }
    },
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
table > tbody > tr td {
  vertical-align: middle;
}

.table > thead > tr > th {
  border: 1px solid #b6c2c9;
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
